<template>
  <lf-button
    type="button"
    class="font-semibold shadow-none transition-colors duration-200"
    :class="[
      {
        'bg-linear-to-bl from-success-button-1 to-success text-white hover:from-success hover:to-success-button-hover-2 focus:to-success-button-focused-2 active:from-success-button-active active:to-success-button-active':
          type == 'success',
      },
      {
        'bg-error/10 text-error hover:bg-error/15 focus:bg-error/20 active:bg-error active:text-white':
          type == 'error',
      },
      {
        'hover:bg-priamry/15 bg-primary/10 text-primary focus:bg-primary/20 active:bg-primary active:text-white':
          type == 'unselected',
      },
      { 'bg-primary text-white': type == 'submit' },
      { 'bg-warning text-white': type == 'warning' },
    ]"
  >
    <slot></slot>
  </lf-button>
</template>
<script setup lang="ts">
import LfButton from "@/components/ui/buttons/LfButton.vue";

withDefaults(
  defineProps<{
    type?: "success" | "warning" | "unselected" | "error" | "submit";
  }>(),
  {
    type: "success",
  }
);
</script>
